const Row = ({ k, v }) => (
  <div className="flex justify-between gap-4 border-b border-white/5 py-2 text-sm"><span className="text-slate-400">{k}</span><span className="font-mono">{v}</span></div>
);

const List = ({ title, items }) =>
  items?.length ? (
    <details className="mt-4 rounded-xl border border-white/10 p-4 text-sm">
      <summary className="cursor-pointer">{title} ({items.length})</summary>
      <ul className="mt-3 list-disc space-y-1 pl-5 text-slate-400">{items.map((x, i) => <li key={i}>{x}</li>)}</ul>
    </details>
  ) : null;

export const ImportReport = ({ job }) => {
  const im = job.images || {};
  return (
    <div className="mt-4 grid gap-6 rounded-2xl border border-white/10 bg-[#12141A] p-6 lg:grid-cols-2" data-testid="import-report">
      <div>
        <p className="mb-2 text-xs text-slate-500">{job.file_name} · {new Date(job.created_at).toLocaleString("it-IT")}</p>
        <Row k="Righe lette" v={job.rows_total} />
        <Row k="Prodotti importati" v={<span data-testid="import-products-count">{job.products}</span>} />
        <Row k="Nuovi / aggiornati" v={`${job.created} / ${job.updated}`} />
        <Row k="Categorie" v={job.categories} />
        <Row k="Prodotti con varianti/opzioni" v={job.products_with_options} />
        <Row k="Gruppi opzioni / valori" v={`${job.option_groups} / ${job.option_values}`} />
        <Row k="Prodotti in evidenza" v={job.featured} />
        <Row k="Righe ignorate" v={job.skipped_rows} />
        <Row k="Immagini salvate nel sito" v={<span data-testid="import-images-status">{im.downloaded}/{im.total} · {im.status}{im.failed?.length ? ` · ${im.failed.length} errori` : ""}</span>} />
      </div>
      <div>
        <p className="mb-2 text-xs text-slate-500">Prodotti per categoria</p>
        {Object.entries(job.by_category || {}).map(([k, v]) => <Row key={k} k={k} v={v} />)}
        <List title="Prodotti senza categoria" items={job.uncategorized} />
        <List title="Prodotti senza immagini" items={job.without_images} />
        <List title="Avvisi" items={job.warnings} />
        <List title="Immagini non scaricate" items={im.failed} />
      </div>
    </div>
  );
};
